export default class Link {
    /**
     * Constructor
     * @param $el
     */
    constructor($el) {
        this.$el = $el;
        this.href = $el.dataset.href;

        this.goToHref = this.goToHref.bind(this);

        this.$el.addEventListener('click', this.goToHref);
    }

    /**
     * Go to href
     * @param e
     */
    goToHref(e) {
        e.preventDefault();
        window.open(this.href, '_blank').focus();
    }
}